import { Typography } from "@mui/material";
import { BODY_SPACING } from "../utils/constants/designConstants";

// Error message component for empty data sections
export const SectionFallback = ({ message }) => (
  <Typography
    variant="body2"
    sx={{
      py: BODY_SPACING.ERROR_MESSAGE_SECTION_PADDING,
      mb: BODY_SPACING.ERROR_MESSAGE_SECTION_MARGIN_BOTTOM,
    }}
  >
    {message}
  </Typography>
);

// USER ACTIVITY TRACKING
export async function formatAxiosError(error) {
  let serverMessage = null;

  if (error.response?.data instanceof Blob) {
    try {
      const text = await error.response.data.text();
      try {
        const parsed = JSON.parse(text);
        serverMessage =
          parsed.error?.message || parsed.detail || parsed.message || text;
      } catch {
        serverMessage = text;
      }
    } catch {
      serverMessage = "Could not read server error response";
    }
  } else if (error.response?.data) {
    // Handle plain JSON error responses
    const data = error.response.data;
    serverMessage = data.error?.message || data.detail || data.message || null;
  }

  const fullError = `
    message: ${error.message}
    status: ${error.response?.status}
    url: ${error.config?.url}
    serverMessage: ${serverMessage ?? "N/A"}
    stack: ${error.stack?.slice(0, 500)}
  `.trim();

  return { fullError, serverMessage };
}
